import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages, useIntl } from 'react-intl';
import { buildSubscriptionPeriodText, getNumberOfEmployeesLabel } from '../../utils/AppUtil';
import useSubscription from '../../hooks/useSubscription';

const i18nMessages = defineMessages({
  month: {
    id: 'account.subscription.month',
    defaultMessage: 'month',
  },
  months: {
    id: 'account.subscription.months',
    defaultMessage: 'months',
  },
  presentNoLimitSubscription: {
    id: 'account.subscription.present-no-limit-subscription',
    defaultMessage: 'Present NoLimit subscription',
  },
  numberOfCandidatesIncluded: {
    id: 'account.subscription.number-of-candidates-included',
    defaultMessage: 'Number of candidates included:',
  },
  unlimited: {
    id: 'account.subscription.unlimited',
    defaultMessage: 'Unlimited',
  },
  numberOfEmployeesIncluded: {
    id: 'account.subscription.number-of-employees-included',
    defaultMessage: 'Number of employees included:',
  },
  prePaidSubscriptionPeriod: {
    id: 'account.subscription.pre-paid-subscription-period',
    defaultMessage: 'Pre-paid subscription period:',
  },
  subscriptionIsAttachedTo: {
    id: 'account.subscription.subscription-is-attached-to',
    defaultMessage: 'Subscription is attached to:',
  },
  priceForSubscriptionPeriod: {
    id: 'account.subscription.price-for-subscription-period',
    defaultMessage: 'Price for subscription period:',
  },
});

const PresentSubscription = ({ clientAccount }) => {
  const { formatMessage } = useIntl();
  const { buildAccountLabel } = useSubscription();

  const {
    subscriptionInformation: {
      currentSubscription: { numberOfEmployees: currentSubscriptionNumberOfEmployees, duration, payedAmount },
    },
  } = clientAccount;

  return (
    <section className="form-section">
      <p>
        <span className="underlined">{formatMessage(i18nMessages.presentNoLimitSubscription)}</span>
      </p>
      <div className="flex-box">
        <div>{formatMessage(i18nMessages.numberOfCandidatesIncluded)}</div>
        <div>{formatMessage(i18nMessages.unlimited)}</div>
      </div>
      <div className="flex-box">
        <div>{formatMessage(i18nMessages.numberOfEmployeesIncluded)}</div>
        <div>{getNumberOfEmployeesLabel(currentSubscriptionNumberOfEmployees)}</div>
      </div>
      <div className="flex-box">
        <div>{formatMessage(i18nMessages.prePaidSubscriptionPeriod)}</div>
        <div>
          {buildSubscriptionPeriodText(formatMessage(i18nMessages.months), formatMessage(i18nMessages.month), duration)}
        </div>
      </div>
      <div className="flex-box">
        <div>{formatMessage(i18nMessages.priceForSubscriptionPeriod)}</div>
        <div>{`$${payedAmount.toLocaleString()}`}</div>
      </div>
      <div className="flex-box">
        <div>{formatMessage(i18nMessages.subscriptionIsAttachedTo)}</div>
        <div>{buildAccountLabel(clientAccount)}</div>
      </div>
    </section>
  );
};

PresentSubscription.propTypes = {
  clientAccount: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default PresentSubscription;
